<template>
  <v-card class="documents matter-engagement-tab">
    <div class="body-content" v-if="currContact">
      <MatterPageList :list="documents"
        v-if="documents.length > 0"
        :class="{'padding-top': completed && documents.length > 5}">
        <template v-slot:list-prview="{ item }">
          <DocumentDetailsRow
              :document="item"
              class="document-row"
              :showStaff="isMultipleStaffs"
              @click="navigateTo" />
        </template>
      </MatterPageList>
      <infinite-loading direction="bottom" :identifier="refreshId" @infinite="infiniteHandler">
        <div slot="spinner">
          <VcLoader/>
        </div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
      <div class="no-results-wrapper" v-if="completed && documents.length === 0">
        <NoResultsCmp
          icon="icon-folder"
          :text="$t('client.matters.matter_page.documents_tab.no_items_found')" />
      </div>
    </div>

    <FabBtn
      :bgColor="brandBgColor"
      :textColor="brandTxtColor"
      custom-class="bottom-right"
      @click="handleBtnClick()"
      icon="icon-documents-plus"
      :tooltip-text="isMobile ? '' : $t('client.matters.matter_page.fabs.documents')"/>

  </v-card>
</template>

<script>
import MatterPageList from "@/modules/matters/components/matterPageList/MatterPageList"
import DocumentDetailsRow from "@/modules/matters/components/documentDetailsRow/DocumentDetailsRow"
import {FabBtn, NoResultsCmp} from "@/modules/common/components"
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: "Documents",
  components: {
    MatterPageList,
    DocumentDetailsRow,
    InfiniteLoading,
    NoResultsCmp,
    FabBtn,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      refreshId: 0
    }
  },
  created() {
    this.$frontageApi.listen('fetch-documents', this.onRefreshEvent)
    this.refresh()
  },
  computed: {
    documents() {
      return this.$store.getters['mattersModule/documents']
    },
    isMultipleStaffs() {
      return this.$store.getters['accountModule/isMultipleStaffs']
    },
    completed() {
      return this.$store.state.mattersModule.documents.completed
    },
    documentsPage() {
      return this.$store.getters['mattersModule/documentsPage']
    },
    currContact() {
      return this.$store.getters['mattersModule/currContact']
    },
    brandBgColor() {
      return this.$store.getters['brandModule/secondaryColor']
    },
    brandTxtColor() {
      return this.$store.getters['brandModule/textColor']
    },
    matter() {
      return this.$store.getters['mattersModule/matter']
    }
  },
  methods: {
    handleBtnClick() {
      this.$frontageApi.send('matter_action', {action: 'add_document', origin: 'Documents tab fab'});
    },
    async infiniteHandler($state) {
      this.isLoading = true
      this.$store.commit("mattersModule/setDocumentsPage", this.documentsPage + 1)
      await this.$store.dispatch({type: "mattersModule/loadDocuments", payload: {clientId: this.currContact.uid, matterId: this.matter.uid}})
      if (this.completed) {
        $state.complete();
        this.isLoading = false
        return
      }

      $state.loaded();
      this.isLoading = false
    },
    navigateTo(doc) {
      this.$frontageApi.navigateTo('app.document.show', {uid: doc.uid});
    },
    onRefreshEvent({clientUid}) {
      if (this.currContact.uid !== clientUid) return

      this.refresh()
    },
    async refresh() {
      this.$store.dispatch({type: "mattersModule/resetDocuments"})
      this.refreshId++
    },
  },
  destroyed() {
    this.$frontageApi.remove('fetch-documents', this.onRefreshEvent)
  }
}
</script>

<style scoped lang="scss">
.documents {
  height: 100%;
  padding: 5px 15px;
  position: relative;

  .body-content {
    height: 100%;
    overflow: auto;

    .padding-top {
      padding-bottom: 50px;
    }
  }

  .no-results-wrapper {
    height: 100%;
  }
}
</style>
